<template>
  <div class="sys-org-add-page main-layout">
    <el-card class="box-form box-outter">
      <c-title slot="header" :title="title"></c-title>
      <el-row class="add-form">
        <el-form
          size="small"
          :model="handleData"
          ref="cForm"
          :rules="formRules"
          :label-width="'150px'"
        >
          <el-col :span="24">
            <c-form-item :formItems="formItems" ref="cFormItem" />
          </el-col>
          <el-col :span="24" style="text-align: center">
            <el-form-item label-width="0">
              <slot name="other">
                <el-button type="primary" @click="submit" size="medium"
                  >保存</el-button
                >
                <el-button
                  class="operation-btn-reset"
                  @click="handleBack"
                  size="medium"
                  >取消</el-button
                >
              </slot>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      title="选择单位"
      :visible.sync="dialogVisible"
      @close="handleDialogClose"
      width="30%"
    >
      <div class="tree-box div-scroll" style="max-height: 550px; padding: 0 5%">
        <div v-loading="handleLoading">
          <el-tree
            :data="treeData"
            :props="defaultProps"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSelectOrg">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/edit";
import { mapState } from "vuex";
let mHandle = MHandle({
  handleGetPath: "/account/sys/org",
  handleInsertPath: "/account/sys/org/create",
  handleUpdatePath: "/account/sys/org/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mHandle],
  data() {
    let { formItems, formRules } = Configs(this);
    return {
      formItems,
      formRules,
      value: {},
      title: "",
      dialogVisible: false,
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      defaultHandleData: {
        id: "",
        name: "",
        parentName: "",
        parentId: "",
        organRange: 0,
        organType: "",
        description: "",
        sort: "",
      },
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  provide() {
    return {
      cForm: this,
    };
  },
  watch: {
    handleData: {
      handler(val) {
        this.value = val;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.handleData = Object.assign({}, this.defaultHandleData);
    this.getTreeData();
    this.value = this.handleData;
    // let id = (this.handleData.id = this.$route.params.id);
    let id =
      this.$route.params.id == "root" ? "%23root" : this.$route.params.id;
    if (id) {
      this.title = "组织机构编辑";
      this.handleGet(id);
    } else {
      this.title = "组织机构新增";
    }
  },
  mounted() {},
  methods: {
    submit(fn) {
      this.$refs.cForm.validate((valid) => {
        if (valid) {
          console.log(this.handleData);
          //   验证通过后将数据提交保存
          if (this.handleData.id) {
            this.handleUpdate();
          } else {
            this.handleInsert();
          }
          fn instanceof Function && fn(this.value);
        } else {
          return false;
        }
      });
    },
    resetFields() {
      this.$refs.cForm.resetFields();
    },
    handleBack() {
      this.$router.go(-1);
    },
    handleAfterFn() {
      // this.$refs.cForm.resetFields();
      this.$router.go(-1);
    },
    handleGetAfterFn(data) {},
    // 对话框关闭
    handleDialogClose() {},
    // 树节点点击操作
    handleNodeClick(data) {
      console.log(data);
      this.handleData.parentId = data.id;
      this.handleData.parentName = data.name;
    },
    // 获取树节点数据
    getTreeData() {
      this.$http.get("/account/sys/org/getOrgTree").then((res) => {
        console.log(res);
        if (res.code == this.SUCCESS_CODE) {
          this.treeData = res.data[0].children;
          console.log(this.treeData);
        }
      });
    },
    handleSelectOrg() {
      this.dialogVisible = false;
    },
  },
  beforeDestroy() {
    this.$refs.cForm.resetFields();
  },
};
</script>
